import { Button, Modal } from '@payaca/ambrosia';
import { FC, type JSX } from 'react';

import useArchiveStockLocation from '@/api/mutations/stockLocations/useArchiveStockLocation';

import { StockLocationListItem } from './CreateEditStockLocationModal';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  stockLocation?: StockLocationListItem;
};

const ConfirmArchiveStockLocationModal: FC<Props> = ({
  isOpen,
  onClose,
  stockLocation,
}): JSX.Element => {
  // A reject (the Location still holds stock) surfaces the offending Materials
  // via the global error toast, so we leave the modal open for the user to act.
  const { mutate: archiveStockLocation, isPending } = useArchiveStockLocation({
    onSuccess: () => onClose(),
  });

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Archive stock location">
      <Modal.Body>
        <p>
          Are you sure you want to archive
          {stockLocation ? ` "${stockLocation.name}"` : ' this stock location'}?
          A location holding stock cannot be archived.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Actions>
          <Button onClick={onClose} variant="secondary" type="button">
            Cancel
          </Button>
          <Button
            colour="negative"
            isProcessing={isPending}
            disabled={!stockLocation}
            onClick={() =>
              stockLocation && archiveStockLocation(stockLocation.id)
            }
          >
            Archive
          </Button>
        </Modal.Footer.Actions>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmArchiveStockLocationModal;
